import React, { Component } from "react";
import { Field } from "formik";

export const validateMinValue = (props) => {
  let minVal = props.minValue ? props.minValue : 0;
  if (minVal >= props.num) {
    return "fas fa-minus-circle fa-2x disabled";
  } else {
    return "fas fa-minus-circle fa-2x";
  }
}

class PlusMinusNumber extends Component {
  constructor(props) {
    super(props);
  }

  render() {
    let styles = 'plus-minus-input ' + this.props.className;
    return (
      <Field name={this.props.name}>
        {({ field, form }) => (
          <div className={styles}>
            <div>
              <span onClick={() => this.props.callBack(form, field, -Number(this.props.incrementBy))}>
                <i className={validateMinValue(this.props)}></i>
              </span>
              <input className="mozilla-override" type="number" value={this.props.num} readOnly />
              <span onClick={() => this.props.callBack(form, field, Number(this.props.incrementBy))}>
                <i className={"fas fa-plus-circle fa-2x" + (this.props.num === this.props.maxValue ? " disabled" : "")}></i>
              </span>
            </div>
          </div>
        )}
      </Field>
    );
  }
}

export default PlusMinusNumber;
